export const sanitizeNumber = (value) => {
  if (typeof value !== 'string') {
    return value; // Return the original value if it's not a string
  }
  return value?.replace(/[, ]+/g, "");
};
